import React from 'react';
import { UniSelectorContext } from './UniSelectorContext';

export const useUniSelectorContext = () => {
  const context = React.useContext(UniSelectorContext);
  if (!context) {
    throw new Error(
      'useUniSelectorContext must be used within a UniSelectorProvider'
    );
  }
  return context;
};
